require(['app/config.js', 'app/services.js', 'app/directives.js', 'app/controllers.js'], function(config, services, directives, controllers) { 
    var app = angular.module('app', ['ngRoute']);
    app.config(config);
    app.service('dataService', services.dataService);
    app.directive('repeatEnd', directives.repeatEnd);
    app.controller('AppCtrl', controllers.appCtrl);
    app.controller('ResultCtrl', controllers.resultCtrl);
});
define("app/app.js", function(){});

